import React, { useEffect } from "react";
import { myTasks5WayStatusesListName } from "src/api/config/myTasksLists.config";
import { fiveWhyStatus, FiveWhyType } from "src/api/config/systemSwitch";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectItems } from "src/modules/spItems/selectors";

export const Statuses5WayNotice = ({ type5Way }: any) => {

    const statuses = useAppSelector((state) => selectItems(state, myTasks5WayStatusesListName));

    return (
        <div className='flex flex-col w-full gap-[10px] p-[10px]'>
            {type5Way && statuses.map((status: any, index: number) => (
                <React.Fragment key={`${status.ID}_${index}`}>
                    {type5Way === 'DeviationReport' && status.ID === fiveWhyStatus.escalate &&
                        <></>
                        ||
                        <div className='flex flex-row w-full items-center gap-[16px]'>
                            <div className="flex justify-end max-w-[110px] w-full">
                                <div style={{ backgroundColor: status.Color }} className="flex flex-row text-black py-[5px] px-[14px] rounded-md text-sm h-fit">{status.Title}</div>
                            </div>
                            <div className="text-black text-sm">{type5Way === FiveWhyType && status.Text5Way || status.TextDeviationReport}</div>
                        </div>
                    }
                </React.Fragment>
            ))}
        </div>
    );
}